<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { computed, ref } from "vue";
import { emitter } from "#/utils/emitter";

const { t } = useTranslation();

interface Props {
	code: string;
	isLoading: boolean;
}

interface Emits {
	submit: [code: string];
	reset: [];
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const promoCode = ref("");
const hasPromo = computed(() => props.code?.length > 0);
const showSubmitButton = computed(() => promoCode.value.trim().length > 0);

const applyPromoCode = () => {
	if (props.isLoading || !showSubmitButton.value) return;
	emitter.emit("keyboard:close");
	emit("submit", promoCode.value);
	promoCode.value = "";
};

const resetPromoCode = () => {
	promoCode.value = "";
	emit("reset");
};
</script>

<template>
	<form class="promo_field" @submit.prevent="applyPromoCode">
		<template v-if="hasPromo">
			<div class="promo_field__label">
				{{ isLoading ? t('promo-field.loading', { code }) : t('promo-field.label', { code }) }}
			</div>
			<button class="promo_field__button" type="reset" @click="resetPromoCode">{{ t('promo-field.button.reset') }}</button>
		</template>
		<template v-else>
			<input
				class="promo_field__input"
				:disabled="isLoading"
				type="text"
				id="promoCode"
				v-model.trim="promoCode"
				data-vk-lift
				:placeholder="t('promo-field.placeholder')"
			>
			<button v-if="showSubmitButton" class="promo_field__button" :disabled="isLoading" type="submit">{{ t('promo-field.button.apply') }}</button>
		</template>
	</form>
</template>

<style scoped lang="scss">
  @use './promoField.scss';
</style>
